<template>
  <div style="height: 100%;" @touchstart="toRoute" @click="toRoute">
    <!-- 标题和切换按钮 -->
    <div class="header-container">
      <label style="margin-top: 15px;font-weight: bold;margin-left: 30px;">
        {{ currentType === 'elec' ? 'PUE' : 'WUE' }}实时值
      </label>
      
      <!-- 切换按钮 -->
      <!-- <div class="switch-buttons">
        <el-button 
          size="mini" 
          type="text" 
          :class="{ active: currentType === 'elec' }" 
          @click.stop="switchType('elec')">PUE</el-button>
        <el-button 
          size="mini"
          type="text" 
          :class="{ active: currentType === 'water' }" 
          @click.stop="switchType('water')">WUE</el-button>
      </div> -->
    </div>
    
    <!-- 图表 -->
    <gauge-chart 
      :data="data" 
      ref="pieChart" 
      style="height: 70%;" 
      v-if="data" 
      :route="route"
      :itPower="itPower" 
      :power="power" 
      :pueValue="pueValue" 
      :id="currentType === 'elec' ? 'elecChart' : 'wueChart'"
      :tagCode="currentType">
    </gauge-chart>
    
    <no-data style="text-align: center;margin-top: 5%" v-else></no-data>
  </div>
</template>

<script>
import gaugeChart from "@/components/echarts/GaugeChart";
import {getRealTimePue} from "@/network/ems-record.js"
import NoData from "@/components/NoData";
import {getSystematicByParent} from "@/network/systematic";
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "Pue",
  mixins: [platenLayoutEdit],
  components: {gaugeChart, NoData},
  props: {
    // 是否开启自动轮显
    autoSwitch: {
      type: Boolean,
      default: true
    },
    // 轮显间隔时间(毫秒)
    switchInterval: {
      type: Number,
      default: 10000  // 默认10秒切换一次
    }
  },
  data() {
    return {
      data: null,
      route: '',
      itPower: 0,
      power: 0,
      pueValue: 0,
      // 新增当前类型变量，elec=PUE, water=WUE
      currentType: 'elec',
      // 系统链接
      systemLinks: {
        elec: '', // PUE系统链接
        water: '' // WUE系统链接
      },
      // 轮显定时器
      switchTimer: null
    }
  },
  created() {
    this.getData();
    this.getLinkage();
    this.$store.dispatch('addIntervalObj', {'getPUE:500000': this.getData});
    
    // 如果开启自动轮显，启动定时器
    if (this.autoSwitch) {
      this.startAutoSwitch();
    }
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getPUE');
    // 清除轮显定时器
    this.clearAutoSwitch();
  },
  methods: {
    // 获取子系统地址
    getLinkage() {
      getSystematicByParent().then(res => {
        if (res && res.data) {
          // 获取PUE系统链接
          let pueSystem = res.data.filter(system => system.appName == "能效系统")[0];
          if (pueSystem) {
            this.systemLinks.elec = pueSystem.website + '#/pueAnalyse';
          }
          
          // 获取WUE系统链接
          let wueSystem = res.data.filter(system => system.appName == "能耗系统")[0];
          if (wueSystem) {
            this.systemLinks.water = wueSystem.website + '#/pueAnalyse';
          }
          
          // 更新当前路由
          this.updateCurrentRoute();
        }
      });
    },
    
    // 更新当前路由
    updateCurrentRoute() {
      this.route = this.systemLinks[this.currentType];
    },
    
    // 切换到指定类型
    switchType(type) {
      if (this.currentType !== type) {
        this.currentType = type;
        this.updateCurrentRoute();
        this.getData();
        
        // 手动切换后，重置自动轮显定时器
        if (this.autoSwitch) {
          this.clearAutoSwitch();
          this.startAutoSwitch();
        }
      }
    },
    
    // 开始自动轮显
    startAutoSwitch() {
      this.clearAutoSwitch(); // 确保先清除现有定时器
      this.switchTimer = setInterval(() => {
        this.switchType(this.currentType === 'elec' ? 'water' : 'elec');
      }, this.switchInterval);
    },
    
    // 清除自动轮显定时器
    clearAutoSwitch() {
      if (this.switchTimer) {
        clearInterval(this.switchTimer);
        this.switchTimer = null;
      }
    },
    
    // 跳转到详情页
    toRoute() {
      if (this.isPlatenLayoutEditing) return
      if (this.route) {
        let url = this.route;
        // PUE需要添加额外参数
        if (this.currentType === 'elec') {
          url += '?tagCode=elec';
        }
        window.open(url, '_blank');
      }
    },
    
    // 获取数据
    getData() {
      getRealTimePue(null, this.currentType).then(res => {
        if (res.code === 0 && res.data !== null) {
          this.data = res.data;
          this.itPower = res.data.itPower;
          this.power = res.data.power;
          this.pueValue = res.data.pueValue;
        } else {
          this.data = null;
        }
      }).catch(() => {
        this.data = null;
      });
    }
  }
}
</script>

<style scoped>
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}

.switch-buttons {
  display: flex;
  align-items: center;
}

.switch-buttons .el-button {
  margin-left: 8px;
  padding: 5px 10px;
  border-radius: 4px;
  color: #606266;
}

.switch-buttons .active {
  color: #409EFF;
  font-weight: bold;
}
</style>
